/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Field_Driver_PhoneInputs */

const en_case_field_driver_phone = /** @type {(inputs: Case_Field_Driver_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact phone`)
};

const pt_br2_case_field_driver_phone = /** @type {(inputs: Case_Field_Driver_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefone de contato`)
};

/**
* | output |
* | --- |
* | "Contact phone" |
*
* @param {Case_Field_Driver_PhoneInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_field_driver_phone = /** @type {((inputs?: Case_Field_Driver_PhoneInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Field_Driver_PhoneInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_field_driver_phone(inputs)
	return pt_br2_case_field_driver_phone(inputs)
});